// This app's own long-established theme key — dozens of components already
// read `localStorage.getItem('theme')` directly, so we keep using it here
// rather than renaming it everywhere.
const KEY = 'theme';
// troopr-ui (same origin, different path) stores its own choice under this
// key with the same values ('default' = follow OS, 'light', 'dark') — see
// troopr-ui/src/lib/theme.js. Mirroring both keys on every write (see
// syncThemeChoice below, and troopr-ui's setTheme) is what lets a theme
// choice made in either app's Settings show up in both.
const SHARED_KEY = 'troopr-theme';

export function isDark() {
  // Hardcoded to white/light theme only. Uncomment original logic below if dark theme is needed later:
  return false;
  /*
  const t = localStorage.getItem(KEY) || 'default';
  return (
    t === 'dark' ||
    (t === 'default' &&
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)
  );
  */
}

// Call this wherever the user changes the theme in this app's Settings, in
// place of a bare `localStorage.setItem('theme', value)`.
export function syncThemeChoice(value) {
  // Hardcoded to default/light theme for trooprbot-ui:
  localStorage.setItem(KEY, 'default');
  localStorage.setItem(SHARED_KEY, 'default');
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.classList.remove('dark');
  }
  /*
  localStorage.setItem(KEY, value);
  localStorage.setItem(SHARED_KEY, value);
  */
}

// logout clears the whole origin's localStorage (session/workspace keys),
// which also wipes the theme preference since it's the same origin as
// troopr-ui — restore both keys afterward so logging out never resets a
// user's chosen theme.
export function clearAuthStorage() {
  // A pending return path must outlive this wipe: it is set BEFORE sign-in and
  // read AFTER it, and the 401 interceptor calls this in between. Clearing it
  // here is what made a deep link survive the redirect but vanish by the time
  // the user finished signing in. A real sign-out clears it separately.
  let pendingReturn = null;
  try {
    pendingReturn = localStorage.getItem('auth_return_to');
  } catch (e) {
    /* ignore */
  }
  localStorage.clear();
  if (pendingReturn) {
    try {
      localStorage.setItem('auth_return_to', pendingReturn);
    } catch (e) {
      /* ignore */
    }
  }
  localStorage.setItem(KEY, 'default');
  localStorage.setItem(SHARED_KEY, 'default');
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.classList.remove('dark');
  }
  /*
  const theme = localStorage.getItem(KEY);
  const sharedTheme = localStorage.getItem(SHARED_KEY);
  if (theme) localStorage.setItem(KEY, theme);
  if (sharedTheme) localStorage.setItem(SHARED_KEY, sharedTheme);
  */
}
